export class TimeZoneConfig {
    localTimeZoneStandardName(): string {
        return 'Eastern Standard Time';
    }

    // standardTimeZoneNameWithTimeZoneIdentifier(timeZoneId: string): void {
    //     console.log('JSTimeZoneConfig::standardTimeZoneNameWithTimeZoneIdentifier not implemented.');
    // }
}
